import {
  FvButton,
  type FvButtonProps,
  type IconProps,
} from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import type { ChargeListState } from './types'

type Props = Omit<FvButtonProps, 'icon'> & {
  icon?: IconProps['icon'] | false
  chargeState: ChargeListState
}

export const ChargesToggle = ({ icon, chargeState, ...buttonProps }: Props) => {
  if (!chargeState.canView) {
    return null
  }

  if (!chargeState.canEdit && buttonProps.children) {
    return buttonProps.children
  }

  const buttonIcon = icon === false ? undefined : icon || 'money-check-alt'

  return (
    <ShipperTooltip
      label={chargeState.canEdit ? 'Edit charges' : 'View charges'}
    >
      <FvButton
        icon={buttonIcon}
        onClick={() => chargeState.toggleViewing()}
        {...buttonProps}
      />
    </ShipperTooltip>
  )
}
